"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildGetEventsRequest = exports.groupEventIdsBySportId = exports.groupTopEvents = void 0;
const dayjs_1 = __importDefault(require("dayjs"));
const selectors_1 = require("astra-core/containers/CommonDataProvider/selectors");
const utils_1 = require("astra-core/containers/CommonDataProvider/utils");
const types_1 = require("astra-core/containers/ConfigProvider/types");
const saga_1 = require("astra-core/containers/ConfigProvider/saga");
const betweb_openapi_axios_1 = require("betweb-openapi-axios");
const effects_1 = require("redux-saga/effects");
const DATE_FORMAT = 'YYYY-MM-DDTHH:mm:ssZ';
function groupTopEvents(events, sports) {
    const eventsIdsBySport = (0, exports.groupEventIdsBySportId)(events, sports);
    const firstSportId = Object.keys(eventsIdsBySport)[0];
    return { firstSportId: Number(firstSportId !== null && firstSportId !== void 0 ? firstSportId : 0), eventsIdsBySport };
}
exports.groupTopEvents = groupTopEvents;
/*
  It takes in account generic sports
*/
const groupEventIdsBySportId = (events, sports) => {
    const result = events.reduce((acc, event) => {
        var _a;
        let { sportId } = event.tournament;
        const sport = sports[sportId];
        if (sport) {
            sportId = (_a = sport.genericSportId) !== null && _a !== void 0 ? _a : sportId;
            if (acc[sportId] === undefined) {
                acc[sportId] = [];
            }
            acc[sportId].push(event.id);
        }
        return acc;
    }, {});
    return result;
};
exports.groupEventIdsBySportId = groupEventIdsBySportId;
function* buildGetEventsRequest({ live, withCursor, }) {
    const newEventsEndpointEnabled = yield (0, effects_1.call)(saga_1.isFeatureFlagEnabledSaga, types_1.EFeatureFlags.NEW_EVENTS_ENDPOINT);
    if (newEventsEndpointEnabled) {
        const entityTags = yield (0, effects_1.select)(selectors_1.selectEntityTags);
        const tagIds = (0, utils_1.getTopTagIds)(entityTags, ['TOP']);
        const reqData = {
            withCursor,
            live,
            statuses: [
                betweb_openapi_axios_1.ActiveEventStatus.Suspended,
                betweb_openapi_axios_1.ActiveEventStatus.Trading,
                betweb_openapi_axios_1.ActiveEventStatus.Planning,
                betweb_openapi_axios_1.ActiveEventStatus.Open,
            ].map((el) => el.replace('EVENT_', '')),
            sort: [
                'sportOrder.asc',
                'groupOrder.asc',
                'tournamentId.asc',
                'scheduledAt.asc',
            ],
            pageSize: 200,
            tagIds,
            tagFilterOperation: betweb_openapi_axios_1.TagFilterOperation.Loose,
        };
        if (live) {
            reqData.scheduledTo = (0, dayjs_1.default)().format(DATE_FORMAT);
        }
        else {
            reqData.scheduledFrom = (0, dayjs_1.default)().format(DATE_FORMAT);
            reqData.hasLineOutcomes = true;
        }
        return reqData;
    }
    return {
        withCursor,
        live,
        top: true,
    };
}
exports.buildGetEventsRequest = buildGetEventsRequest;
//# sourceMappingURL=index.js.map